export const cpus = () => [];

export default { cpus };
